import { z } from 'zod';
import { readStoredJson } from './readStoredJson';

const CHUNK_RELOAD_KEY = 'terra:chunk-reload-attempted';

/** Minimum gap between two chunk-failure reloads in the same tab. */
export const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

/**
 * Claim permission to reload the page after a stale-chunk failure. The claim time is stored in
 * sessionStorage, which survives the reload, so a chunk that stays missing reloads at most once
 * per cooldown window instead of looping. Returns false inside the window or when storage is
 * unavailable. Every chunk-failure path shares this one key.
 */
export function claimChunkReload(now: number = Date.now()): boolean {
  try {
    const last = readStoredJson(sessionStorage, CHUNK_RELOAD_KEY, z.number().finite(), 0);
    if (last && now - last < CHUNK_RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}
